// hooks/purchases/useCreditNoteLookup.ts
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import useLoading from '../useLoading';
import useAlerts from '../useAlerts';
import {
  setFilteredDocuments,
  setProductOptions,
  clearFilteredDocuments,
  clearProductOptions,
} from '../../store/slices/purchases/creditNoteLookupSlice';
import CreditNoteLookupService from '../../services/purchases/CreditNoteLookupService';
import { CreditNoteLookupFilter } from '../../types/purchases/CreditNoteLookup';

export const useCreditNoteLookup = () => {
  const dispatch = useDispatch();
  const { show: showAlert } = useAlerts();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const { filteredDocuments, productOptions } = useSelector(
    (state: RootState) => state.creditNoteLookup
  );

  const searchEligiblePurchases = async (filters: CreditNoteLookupFilter) => {
    try {
      showLoadingIndicator();
      const response = await CreditNoteLookupService.searchEligiblePurchases(filters);

      if (response.statusCode === 200) {
        dispatch(setFilteredDocuments(response.data));
      } else {
        showAlert('error', 'Error', 'No se pudieron obtener los documentos.');
      }
    } catch (error) {
      console.error('❌ Error al buscar documentos:', error);
      showAlert('error', 'Error', 'Ocurrió un error inesperado.');
    } finally {
      hideLoadingIndicator();
    }
  };

  const fetchProductsByPurchase = async (purchaseId: number) => {
    try {
      showLoadingIndicator();
      const response = await CreditNoteLookupService.getProductsByPurchase(purchaseId);
        console.log(response);
      if (response.statusCode === 200) {
        dispatch(setProductOptions(response.data));
      } else {
        showAlert('error', 'Error', 'No se pudieron obtener los productos.');
      }
    } catch (error) {
      console.error('❌ Error al obtener productos:', error);
      showAlert('error', 'Error', 'Ocurrió un error inesperado.');
    } finally {
      hideLoadingIndicator();
    }
  };

  const clearCreditNoteLookup = () => {
    dispatch(clearFilteredDocuments());
    dispatch(clearProductOptions());
  };

  return {
    filteredDocuments,
    productOptions,
    searchEligiblePurchases,
    fetchProductsByPurchase,
    clearCreditNoteLookup,
  };
};
